
@switch (columnId) {
  @case ('adjustmentDate') {
    <lib-date-time-label [dateUtc]="element.adjustmentDate" [rawDateWithNoTime]="true"></lib-date-time-label>
  }
  @case ('amount') {
    <lib-text-table-column>
      {{ element?.amount | vituCurrencyUsd }}
    </lib-text-table-column>
    <lib-table-column-sort [key]="element.amount ?? 0"></lib-table-column-sort>
  }
  @case ('createdUtc') {
    <lib-date-time-label [dateUtc]="element.createdUtc"></lib-date-time-label>
  }
  @case ('reason') {
    <lib-text-table-column>
      {{ element?.reason | spaceBetweenCaps }}
    </lib-text-table-column>
  }
  @case ('type') {
    <lib-text-table-column>
      {{ element?.type | spaceBetweenCaps }}
    </lib-text-table-column>
  }
  @default {
  }
}
